/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpsertGlobalToolVariationForm,
  UpsertGlobalToolVariationForm$Outbound,
  UpsertGlobalToolVariationForm$outboundSchema,
} from "../components/upsertglobaltoolvariationform.js";

export type UpsertGlobalVariationSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpsertGlobalVariationSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpsertGlobalVariationSecurity = {
  option1?: UpsertGlobalVariationSecurityOption1 | undefined;
  option2?: UpsertGlobalVariationSecurityOption2 | undefined;
};

export type UpsertGlobalVariationRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  upsertGlobalToolVariationForm: UpsertGlobalToolVariationForm;
};

/** @internal */
export type UpsertGlobalVariationSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpsertGlobalVariationSecurityOption1$outboundSchema: z.ZodMiniType<
  UpsertGlobalVariationSecurityOption1$Outbound,
  UpsertGlobalVariationSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function upsertGlobalVariationSecurityOption1ToJSON(
  upsertGlobalVariationSecurityOption1: UpsertGlobalVariationSecurityOption1,
): string {
  return JSON.stringify(
    UpsertGlobalVariationSecurityOption1$outboundSchema.parse(
      upsertGlobalVariationSecurityOption1,
    ),
  );
}

/** @internal */
export type UpsertGlobalVariationSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpsertGlobalVariationSecurityOption2$outboundSchema: z.ZodMiniType<
  UpsertGlobalVariationSecurityOption2$Outbound,
  UpsertGlobalVariationSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function upsertGlobalVariationSecurityOption2ToJSON(
  upsertGlobalVariationSecurityOption2: UpsertGlobalVariationSecurityOption2,
): string {
  return JSON.stringify(
    UpsertGlobalVariationSecurityOption2$outboundSchema.parse(
      upsertGlobalVariationSecurityOption2,
    ),
  );
}

/** @internal */
export type UpsertGlobalVariationSecurity$Outbound = {
  Option1?: UpsertGlobalVariationSecurityOption1$Outbound | undefined;
  Option2?: UpsertGlobalVariationSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpsertGlobalVariationSecurity$outboundSchema: z.ZodMiniType<
  UpsertGlobalVariationSecurity$Outbound,
  UpsertGlobalVariationSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpsertGlobalVariationSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpsertGlobalVariationSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function upsertGlobalVariationSecurityToJSON(
  upsertGlobalVariationSecurity: UpsertGlobalVariationSecurity,
): string {
  return JSON.stringify(
    UpsertGlobalVariationSecurity$outboundSchema.parse(
      upsertGlobalVariationSecurity,
    ),
  );
}

/** @internal */
export type UpsertGlobalVariationRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpsertGlobalToolVariationForm: UpsertGlobalToolVariationForm$Outbound;
};

/** @internal */
export const UpsertGlobalVariationRequest$outboundSchema: z.ZodMiniType<
  UpsertGlobalVariationRequest$Outbound,
  UpsertGlobalVariationRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    upsertGlobalToolVariationForm: UpsertGlobalToolVariationForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      upsertGlobalToolVariationForm: "UpsertGlobalToolVariationForm",
    });
  }),
);

export function upsertGlobalVariationRequestToJSON(
  upsertGlobalVariationRequest: UpsertGlobalVariationRequest,
): string {
  return JSON.stringify(
    UpsertGlobalVariationRequest$outboundSchema.parse(
      upsertGlobalVariationRequest,
    ),
  );
}
